<script setup lang="ts">
  const { showHelpModal, isHelpMessageSendedSuccess } = storeToRefs(useBookingStore());
</script>

<template>
  <div class="overlay" @click.self="showHelpModal = false">
    <div class="select-doctor-modal">
      <div class="line"></div>
      <PatientHelpFormModalForm v-if="!isHelpMessageSendedSuccess" />
      <PatientHelpFormModalFormSended v-else />
    </div>
  </div>
</template>

<style scoped lang="scss">
.overlay {
  z-index: 903;
  position: fixed;
  display: flex;
  align-items: center;
  justify-content: center;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  @media (max-width: 1023px) {
    align-items: flex-end;
  }
}
.select-doctor-modal {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-direction: column;
  width: 584px;
  background-color: white;
  border-radius: 24px;
  padding: 28px;
  @media (max-width: 1023px) {
    width: 100%;
    height: 80%;
    border-radius: 24px 24px 0px 0px;
    padding: 12px 20px 28px 20px;
  }
  @media (max-width: 880px) {
    height: 100%;
  }
}
.line {
  z-index: 901;
  position: absolute;
  display: none;
  left: 50%;
  transform: translate(-50%, 0);
  width: 32px;
  height: 4px;
  border-radius: 3px;
  opacity: 0.2;
  background-color: #000;
  @media (max-width: 1023px) {
    display: block;
  }
}
</style>
